import type { BoxProps } from '@mui/material/Box';
import type { Breakpoint } from '@mui/material/styles';

import Box from '@mui/material/Box';

import { CarouselAutoplay } from 'src/sections/carousel/auto-play';

// ----------------------------------------------------------------------

export type AuthSplitSectionProps = BoxProps & {
  title?: string;
  method?: string;
  imgUrl?: string;
  subtitle?: string;
  layoutQuery?: Breakpoint;
  methods?: {
    path: string;
    icon: string;
    label: string;
  }[];
};

export function AuthSplitSection({
  sx,
  method,
  methods,
  layoutQuery = 'sm',
  title = 'Manage the job',
  imgUrl = `/assets/illustrations/illustration-login1.svg`,
  subtitle = 'More effectively with optimized workflows.',
  ...other
}: AuthSplitSectionProps) {
  const carouselArray = [
    {
      id: '1',
      title: 'Minutes Saved. Hours Earned.',
      description: 'Get straight to Hiring.',
      coverUrl: '/assets/illustrations/illustration-login1.svg',
    },
    {
      id: '2',
      title: 'Discover Talent the Modern way',
      description: 'AI-powered hiring solutions to build your perfect team.',
      coverUrl: '/assets/illustrations/illustration-dashboard.webp',
    },
    {
      id: '3',
      title: 'Identify Top Performers Efficiently.',
      description: 'Identify Top Performers Efficiently.',
      coverUrl: '/assets/illustrations/illustration-dashboard.webp',
    },
    {
      id: '4',
      title: 'Empower Recruiters with Data-Driven Insights.',
      description: 'Identify Top Performers Efficiently.',
      coverUrl: '/assets/illustrations/illustration-dashboard.webp',
    }
  ]
  return (
    <Box
      sx={[
        (theme) => ({
          backgroundColor: theme.palette.primary.dark,
          px: 3,
          pb: 3,
          width: 1,
          maxWidth: '40%',
          display: 'none',
          position: 'relative',
          pt: 'var(--layout-header-desktop-height)',
          [theme.breakpoints.up(layoutQuery)]: {
            gap: 8,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <CarouselAutoplay data={carouselArray} />
    </Box>
  );
}
